import React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { DateTime } from 'luxon'
import { cn } from '@/lib/utils'

interface TimeDisplayProps {
  date: Date | string
  className?: string
  formatter?: (date: Date | string) => string
}

/**
 * Display time with a tooltip showing full date/time on hover
 */
export const TimeDisplay: React.FC<TimeDisplayProps> = ({
  date,
  className = '',
  formatter,
}) => {
  const jsDate = date instanceof Date ? date : new Date(date)
  const dt = DateTime.fromJSDate(jsDate)

  // Abbreviated format for tooltip: "Tue, Dec 24, 2024, 11:58:32 AM"
  const fullDateTime = dt.toFormat('MMM d, yyyy, h:mm:ss a')

  // Display format (either custom formatter or the date itself)
  const displayText = formatter ? formatter(date) : String(date)

  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={cn(className, 'cursor-help')}>{displayText}</span>
        </TooltipTrigger>
        <TooltipContent
          side="bottom"
          className="text-xs w-fit max-w-[110px] inline-block"
        >
          <span>{fullDateTime}</span>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
